export default __webpack_public_path__ + "static/media/steps-cover-4.5c893c65.png";